import { DetectorType } from "../../utils/enum";
import { IS, now } from "../../utils/util";
import { Detector } from "../detector";

export default class extends Detector {

  constructor() {
    super({
      type: DetectorType.Debugger,
      enabled: IS.iosChrome || IS.iosEdge,
    });
  }

  detect() {
    const date = now();
    (() => {debugger;})();
    if (now() - date > 100) {
      this.onDevToolOpen();
    }
  }
}